import { render, staticRenderFns } from "./SalesTransactions.vue?vue&type=template&id=612e9621&scoped=true"
import script from "./SalesTransactions.vue?vue&type=script&lang=js"
export * from "./SalesTransactions.vue?vue&type=script&lang=js"
import style0 from "./SalesTransactions.vue?vue&type=style&index=0&id=612e9621&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "612e9621",
  null
  
)

export default component.exports